<template>
  <div class="first" v-if="isMounted" >
    <div class="heading-f">
      <div class="title-sx d-flex">
        <img
            class="filter-icon"
            :src="url('/media/icons/svg/filtro-black.svg')"
            alt="filtro"
        />
        <span>{{ trans.get("b2b.filter.filter-products") }}</span>
      </div>
      <div class="title-dx d-flex" @click="closeModal">
        <img
            class="cross-icon"
            :src="url('/media/icons/svg/cross-black.svg')"
            alt="chiudi"
        />
        <span>{{ trans.get("b2b.filter.close") }}</span>
      </div>
    </div>
    <div class="title-f">
      <span>{{ trans.get("b2b.filter.product") }}</span>
    </div>
    <div class="family" v-if="currentFamilyTree">
      <ul v-for="family in currentFamilyTree.famiglie">
        <li
            v-if="
            (family.categorie && family.categorie.length > 0) ||
            (family.microfamiglie && family.microfamiglie.length > 0)

          "
            :id="parseId(family.codice)"
            class="row-fam"
        >
          <div class="wrap-f">
            <span class="fam-desc" @click="toggleFamily(family.codice)">{{
                family.descrizione
              }}</span>
            <span class="fam-img">
              <img
                  @click="toggleFamily(family.codice)"
                  :src="url('/media/icons/svg/plus.svg')"
                  alt="plus"
              />
            </span>
          </div>
          <div class="wrap-m">
            <ul class="categories" v-if="family.microfamiglie">
              <li
                  class="micro-row"
                  :id="microf.codice"
                  v-for="microf in family.microfamiglie"
              >
                <img
                    class="plus"
                    :src="url('/media/icons/svg/plus.svg')"
                    alt="plus"
                    @click.stop="toggleMicro(microf.codice)"
                />
                <img
                    class="minus hide"
                    :src="url('/media/icons/svg/minus.svg')"
                    alt="minus"
                    @click.stop="toggleMicro(microf.codice)"
                />
                <span @click.stop="toggleMicro(microf.codice)">{{
                    microf.descrizione
                  }}</span>
                <ul class="categs">
                  <li
                      :id="microf.codice"
                      class="categorie check"
                      v-for="cat in microf.categorie"
                  >
                    <input
                        :id="family.codice + '-' + cat.codice"
                        type="checkbox"
                        @change="
                        loadColors(family.codice, cat.codice);
                        collectFilters(family.codice, cat.codice);
                      "
                    />
                    <label :for="family.codice + '-' + cat.codice">{{
                        cat.descrizione
                      }}</label>
                  </li>
                </ul>
              </li>
            </ul>
            <ul class="categories" v-else-if="!family.microfamiglie">
              <li class="categorie check" v-for="cat in family.categorie">
                <input
                    :id="parseId(family.codice) + '-' + cat.codice"
                    type="checkbox"
                    @change="
                    loadColors(family.codice, cat.codice);
                    collectFilters(family.codice, cat.codice);
                  "
                />
                <label :for="parseId(family.codice) + '-' + cat.codice">
                  {{ cat.descrizione }}</label
                >
              </li>
            </ul>
          </div>
        </li>
      </ul>
    </div>
    <div class="color">
      <div class="title-colori">
        <img :src="url('/media/icons/png/colorwheel.png')" alt="color wheel"/>

        <span>{{ trans.get("b2b.filter.colour") }}</span>
      </div>

      <div class="lista-colori">
        <ul v-if="currentColors" v-for="color in currentColors">
          <li class="check">
            <input
                type="checkbox"
                :id="color.code"
                @change="collectFiltersColor(color.code)"
            />
            <label :for="color.code">
              {{ color.descrizione }}
            </label>
          </li>
        </ul>
      </div>
    </div>
    <a class="link-ret green filter-footer" @click="applyFilter">
      {{ trans.get("b2b.filter.apply") }}
    </a>
  </div>
</template>

<script>
export default {
  props: ['reset'],
  data: function () {
    return {
      isMounted: false,
      tree: [],
      macro: null,
      family: null,
      micro: null,
      categories: null,
      articles: null,
      catmicro: null,
      selectedMacro: "",
      currentFamilyTree: null,
      currentMicroFam: [],
      currentColors: [],
      currentMacroFam: null,
      filterCategory: [],
      filterColor: [],
      filterFamily: [],


    };
  },
  mounted() {
    this.loadMacro();

    },


  methods: {
    parseId: function (code) {
      return code.replace(/\+/g, "plus");
    },
    applyFilter: function () {
      if (this.filterCategory.length > 0) {

        axios({
          method: 'get',
          url: window.location.origin + '/b2b/getCardCode',
          params: {
            famiglia: this.filterFamily,
            categoria: this.filterCategory,
            colore: this.filterColor
          }
        }).then(res => {
          let array = []
          res.data.forEach(el => {
            array.push(el.codice)
          })
          this.$emit("applyFilter", array);
        })

        this.closeModal();
      } else {
        alert("Selezionare almeno una categoria ed un colore");
      }
    },
    collectFilters: function (family, category) {
      //console.log(family, category);
      let selectedCategoryCheckbox = $("#" + this.parseId(family) + "-" + category);
      if (selectedCategoryCheckbox.prop("checked")) {
        //add
        if (!this.filterCategory.includes(category))
          this.filterCategory.push(category);
        if (!this.filterFamily.includes(family)) this.filterFamily.push(family);
      } else {
        this.filterFamily.forEach((item) => {
          if (item === family) {
            let remove = this.filterFamily.indexOf(item);
            this.filterFamily.splice(remove, 1);
          }
        });
        this.filterCategory.forEach((item) => {
          if (item === category) {
            let remove = this.filterCategory.indexOf(item);
            this.filterCategory.splice(remove, 1);
          }
        });
      }
      //console.log('filterscat', this.filterCategory)
    },

    collectFiltersColor: function (colore) {
      //console.log(colore)
      let selectedColorCheckbox = $("#" + colore);
      if (selectedColorCheckbox.prop("checked")) {
        if (!this.filterColor.includes(colore)) this.filterColor.push(colore);
      } else {
        this.filterColor.forEach((item) => {
          if (item === colore) {
            let remove = this.filterColor.indexOf(item);
            this.filterColor.splice(remove, 1);
          }
        });
      }
    },
    //metodi per aprire e chiudere sezioni
    closeModal: function () {
      this.$emit("closeMe");
    },
    toggleFamily: function (id) {
      id = this.parseId(id);
      let family = $("#" + id);
      family.children(".wrap-m").toggle();
      family.children(".wrap-m").addClass("open");
      family.toggleClass("selected-f");
    },
    toggleMicro: function (id) {
      let microfamily = $("#" + id);
      microfamily.children(".categs").toggle();
      microfamily.children("img.plus").toggleClass("hide");
      microfamily.children("img.minus").toggleClass("show");
      microfamily.children("img.minus").toggleClass("hide");
    },
    //metodi per caricare tutta l'alberatura
    loadColors: function (family, codcat) {
      //console.log(family, codcat)
      let listaColori = $(".lista-colori:hidden");
      let checkbox = $("#" + this.parseId(family) + "-" + codcat);
      if (listaColori) {
        listaColori.show();
      } else {
        listaColori.hide();
      }
      axios({
        method: "get",
        url: window.location.origin + "/data/get-family",
        params: {
          cod: codcat,
          famiglia: family,
          type: "colori_f",
        },
      })
          .then((result) => {
            if (checkbox.prop("checked")) {
              // se selezionato
              result.data.family.forEach((item, i) => {
                var trovato = this.currentColors.find(function (obj, i) {
                  return obj.code === item.cod_colore;
                });
                if (trovato) {
                  let index = this.currentColors.findIndex(function (el) {
                    return el.code === item.cod_colore;
                  });
                  this.currentColors[index].count++;
                } else {

                  this.currentColors.push({
                    code: item.cod_colore,
                    descrizione: item.color.descrizione,
                    count: 1,
                  });
                }
              });
            } else {
              //se deselezionato
              result.data.family.forEach((item, i) => {
                var trovato = this.currentColors.find(function (obj, i) {
                  return obj.code === item.cod_colore;
                });
                if (trovato) {
                  let index = this.currentColors.findIndex(function (el) {
                    return el.code === item.cod_colore;
                  });
                  this.currentColors[index].count--;
                }
              });
            }
            this.currentColors = this.currentColors.filter((el) => el.count > 0);
          })
          .catch((err) => {
            this.$store.commit("add_message", {
              type: "error",
              message: err.response.data.message,
            });
          });
    },
    loadMacro() {
      axios({
        method: 'get',
        url: window.location.origin + '/b2b/filter',
      }).then(res => {
        this.tree = res.data.tree
        //console.log(res.data.tree)
        this.getFamilies(sessionStorage.macrofam)
        this.isMounted = true
      })
    },
    // loadMacro: function () {
    //   axios({
    //     method: "get",
    //     url: window.location.origin + "/data/get-family",
    //     params: {
    //       type: "filter-m",
    //     },
    //   })
    //       .then((result) => {
    //         let macro = result.data.family;
    //         let tutto = [];
    //         //console.log('loadmacro: ', result.data.family)
    //         macro.forEach((item, index) => {
    //           let key = item.codice;
    //           this.loadFamily(item.codice, function (res) {
    //             tutto.push({
    //               code: item.codice,
    //               descrizione: item.descrizione,
    //               ordinamento: item.ordinamento,
    //               famiglie: res,
    //             });
    //           });
    //         });
    //         this.tree = tutto;
    //         setTimeout(()=>{
    //           this.getFamilies(sessionStorage.macrofam);
    //         },1000)
    //
    //         this.isMounted = true;
    //       })
    //       .catch((err) => {
    //         this.$store.commit("add_message", {
    //           type: "error",
    //           message: err.response.data.message,
    //         });
    //       });
    // },
    // loadFamily: function (macrofam, callback) {
    //   axios({
    //     method: "get",
    //     url: window.location.origin + "/data/get-family",
    //     params: {
    //       cod: macrofam,
    //       type: "filter-f",
    //     },
    //   })
    //       .then((result) => {
    //         let famiglie = result.data.family;
    //         let tutto_f = [];
    //         famiglie.forEach((item) => {
    //           if (item.microfamily.length > 0) {
    //             this.loadMicro(item.codice, function (res) {
    //               tutto_f.push({
    //                 code: item.codice,
    //                 descrizione: item.descrizione,
    //                 microfamiglie: res,
    //                 ordinamento: item.ordinamento,
    //               });
    //               //console.log(item.codice, res)
    //
    //             });
    //           } else {
    //             this.loadCategoriesNoMicro(item.codice, function (res) {
    //               tutto_f.push({
    //                 code: item.codice,
    //                 descrizione: item.descrizione,
    //                 microfamiglie: null,
    //                 categorie: res,
    //                 ordinamento: item.ordinamento,
    //               });
    //             });
    //           }
    //         });
    //         setTimeout(()=>{
    //           tutto_f = _.orderBy(tutto_f, 'ordinamento', 'desc')
    //         }, 500)
    //
    //
    //
    //
    //
    //
    //         callback(tutto_f);
    //       })
    //       .catch((err) => {
    //         this.$store.commit("add_message", {
    //           type: "error",
    //           message: err.response.data.message,
    //         });
    //       });
    // },
    // loadMicro: function (family, callback) {
    //   axios({
    //     method: "get",
    //     url: window.location.origin + "/data/get-family",
    //     params: {
    //       cod: family,
    //       type: "filter-micro",
    //     },
    //   })
    //       .then((result) => {
    //         let microfamilies = result.data.family;
    //         let tutto_micro = [];
    //
    //         if (microfamilies.length > 0) {
    //           microfamilies.forEach((el) => {
    //             this.loadCategories(el.codice, function (res) {
    //               if (res[0] !== null) {
    //                 tutto_micro.push({
    //                   code: el.codice,
    //                   descrizione: el.descrizione,
    //                   microfamily: true,
    //                   categorie: res,
    //                 });
    //               }
    //             });
    //           });
    //           //console.log(family, tutto_micro)
    //           callback(tutto_micro);
    //         }
    //       })
    //       .catch((err) => {
    //         this.$store.commit("add_message", {
    //           type: "error",
    //           message: err.response.data.message,
    //         });
    //       });
    // },
    // loadCategories: function (microfam, callback) {
    //   axios({
    //     method: "get",
    //     url: window.location.origin + "/data/get-family",
    //     params: {
    //       cod: microfam,
    //       type: "filter-categories",
    //     },
    //   })
    //       .then((result) => {
    //         let microfamilies = result.data.family;
    //         let tutto_c = [];
    //
    //         if (microfamilies.length > 0) {
    //           microfamilies.forEach((el) => {
    //             tutto_c.push({
    //               code: el.cod_categoria,
    //               descrizione: el.category.descrizione,
    //               ordinamento: el.category.ordinamento
    //             });
    //           });
    //         } else {
    //           tutto_c.push(null);
    //         }
    //
    //         tutto_c = _.orderBy(tutto_c, 'ordinamento', 'asc')
    //         callback(tutto_c);
    //       })
    //       .catch((err) => {
    //         this.$store.commit("add_message", {
    //           type: "error",
    //           message: err.response.data.message,
    //         });
    //       });
    // },
    // loadCategoriesNoMicro: function (fam, callback) {
    //   axios({
    //     method: "get",
    //     url: window.location.origin + "/data/get-family",
    //     params: {
    //       cod: fam,
    //       type: "filter-categories-nomicro",
    //     },
    //   })
    //       .then((result) => {
    //         let families = result.data.family;
    //         //console.log('load no micro ',fam, result.data.family)
    //         let tutto_c = [];
    //
    //         if (families.length > 0) {
    //           families.forEach((el) => {
    //             tutto_c.push({
    //               code: el.cod_categoria,
    //               descrizione: el.category.descrizione,
    //               ordinamento: el.category.ordinamento
    //             });
    //           });
    //         }
    //
    //
    //         tutto_c = _.orderBy(tutto_c, 'ordinamento', 'asc')
    //
    //
    //         callback(tutto_c);
    //       })
    //       .catch((err) => {
    //         this.$store.commit("add_message", {
    //           type: "error",
    //           message: err.response.data.message,
    //         });
    //       });
    // },
    //metodo per selezionare la famiglia in base alla macrofamiglia
    getFamilies: function (codemacro) {
      this.tree.forEach((item) => {
        if (item.codice === codemacro) {
          this.currentFamilyTree = item;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
li.check {
  display: flex;
  align-items: center;
  cursor: pointer;
  margin-bottom: 3px;

  label {
    margin-bottom: 0;
    margin-left: 10px;
  }

  input[type="checkbox"] {
    /* Add if not using autoprefixer */
    -webkit-appearance: none;
    appearance: none;
    /* For iOS < 15 to remove gradient background */
    background-color: #fff;
    /* Not removed via appearance */
    margin: 0;
    font: inherit;
    color: currentColor;
    width: 1.15em;
    height: 1.15em;
    // border: 1px solid currentColor;
    // border-radius: 0.15em;
    transform: translateY(-0.075em);
    display: grid;
    place-content: center;
    // display: inline-block;
    cursor: pointer;

    &::before {
      content: "";
      width: 0.65em;
      height: 0.65em;
      transform: scale(0);
      transition: 120ms transform ease-in-out;
      box-shadow: inset 1em 1em #0065ff;
      /* Windows High Contrast Mode */
      background-color: CanvasText;
      transform-origin: bottom left;
      clip-path: polygon(14% 44%, 0 65%, 50% 100%, 100% 16%, 80% 0%, 43% 62%);
    }

    &:checked::before {
      transform: scale(1);
    }

    &:focus {
      outline: max(2px, 0.15em) solid currentColor;
      // outline-offset: max(2px, 0.15em);
    }
  }
}

.first {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 3;
  background: #ffffff;
  font-size: 18px;
  width: 100%;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  @media (orientation: landscape) and (max-width: 1400px) {
    height: calc(100vh - 80px)

  }
  .heading-f {
    padding: 32px 38px;
    display: flex;
    justify-content: space-between;

    .title-sx {
      img {
        margin-right: 15px;
      }
    }

    .title-dx {
      cursor: pointer;

      img {
        margin-right: 15px;
      }
    }
  }

  .title-f {
    background-color: var(--black-2);
    color: var(--text-white);
    padding: 17px 38px;
  }

  .macrofamily {
    background-color: #d8d8d8;
    display: flex;
    justify-content: center;
    padding: 14px 39px;
    border-bottom: 1px solid #979797;
    font-size: 15px;

    .f-option {
      display: flex;
      justify-content: center;

      input {
        transform: scale(1.5);
        align-self: center;
        margin-right: 10px;
      }
    }

    label {
      display: inline-block;
      text-transform: lowercase;
    }

    label:first-letter {
      text-transform: capitalize;
    }
  }

  .family ul .row-fam {
    background-color: #e7e6e6;
    border-bottom: 1px solid #979797;
    padding: 10px 39px 3px;
    display: flex;
    font-size: 14px;
    flex-direction: column;
    transition: all 2s linear 1s;
    cursor: pointer;

    span {
      cursor: pointer;
    }

    .wrap-f {
      display: flex;
      width: 100%;
      align-items: center;

      .fam-desc {
        display: inline-block;
        text-transform: lowercase;

        &:first-letter {
          text-transform: capitalize;
        }
      }

      .fam-img {
        margin-left: auto;

        img {
          width: 13px;
        }
      }
    }

    .wrap-m {
      display: none;
      flex-direction: column;
      font-size: 11px;
      margin-top: 18px;
      height: 0;
      // transition: all 0.5s linear;
      //animation-name: wrap;
      //animation-duration: 0.5s;
      & > * {
        opacity: 0;
        //animation-name: opa;
        //animation-duration: 1s;
      }

      &.open {
        height: auto;

        & > * {
          opacity: 1;
        }
      }

      @keyframes wrap {
        from {
          height: 0;
        }
        to {
          height: auto;
        }
      }

      @keyframes opa {
        from {
          opacity: 0;
        }
        to {
          opacity: 1;
        }
      }

      .microfamily,
      .categories,
      .catmicro {
        border: none;

        li {
          text-transform: lowercase;
          margin-left: 40px;
        }

        img {
          display: inline-block;
          margin-right: 12px;
          width: 12px;
        }

        label {
          cursor: pointer;
        }

        span,
        label {
          display: inline-block;

          &:first-letter {
            text-transform: uppercase;
          }
        }
      }

      &:first-letter {
        text-transform: uppercase;
      }

      .categories {
        li {
          img.show {
            display: inline-block;
          }

          img.hide {
            display: none;
          }

          ul {
            display: none;

            .categorie:first-child {
              margin-top: 14px;
            }

            .categorie {
              margin-bottom: 3px;

              label {
                cursor: pointer;
              }
            }

            .categorie:last-child {
              margin-bottom: 17px;
            }
          }
        }
      }
    }

    &.selected-f {
      background-color: #ffffff;
      height: auto;

      div > span > img {
        width: 13px;
        transform: rotate(-45deg);
      }
    }
  }

  .color {
    font-size: 18px;
    color: white;
    line-height: 18px;

    display: flex;
    flex-direction: column;

    .title-colori {
      padding: 17px 38px;
      display: flex;
      background-color: #0065ff;

      span {
        margin-left: 11px;
      }
    }

    .lista-colori {
      font-size: 15px;
      padding: 17px 38px;
      width: 100%;
      display: none;
      color: var(--black-2);
      background-color: #fff;
      padding-top: 21px;

      label {
        text-transform: lowercase;

        &:first-letter {
          text-transform: uppercase;
        }
      }
    }
  }

  .filter-footer {
    display: flex;
    color: var(--black-2);
    max-width: 100%;

    margin-top: auto;
    //height: 128px;
    align-items: center;
    padding: 30px 60px;
  }
}

@media (min-width: 768px) {
  .first {
    //width: 500px;
    .family ul .row-fam .wrap-m {
      font-size: 14px;
    }
  }
}
</style>
